import TableFilter from './TableFilter'

export default TableFilter


// WEBPACK FOOTER //
// ./resources/assets/js/components/TableFilter/index.js